import * as _ from 'lodash';
import { BoldIdGeneratorService } from 'common/bold-id-generator/bold-id-generator.service';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { EmailItem } from '../interfaces/email-item.interface';
import { WorkItemEmail } from './work-item-email';
import { WorkItemPool } from '../workitem-pool';

export class WorkItemComposeEmail extends WorkItemEmail implements EmailItem {
  public readonly type: string = WorkItemTypes.COMPOSE_EMAIL;

  constructor(workItem) {
    super(workItem);

    if (workItem) {
      // TODO: use a private property for the model
      // and create getters to this private model
      _.assign(this, workItem);
    } else {
      this._createNew();
    }
  }

  _createNew() {
    const IdGenerator = BoldIdGeneratorService();
    this._id = `${WorkItemTypes.COMPOSE_EMAIL}_${IdGenerator.generateId()}`;
    this._isCollapsible = true;
    this.isClosable = true;

    WorkItemPool.getInstance().addWorkItem(this);
  }
}
